<template>
  <div class="faq">
    <h2>FAQS</h2>
    <ul class="faq-list">
      <li class="faq-item" v-for="(item,index) in faqList" :key="index">
        <p class="question" @click="ask(index)">
          <span> Q: {{ item.q }}</span>
          <i v-if="activeIndex !== index" class="iconfont icon-jia"/>
          <i v-else class="iconfont icon-jian"/>
        </p>
        <p class="answer" :style="{display: index === activeIndex ? 'block':'none'}"> <span style="color: red">A</span> : {{ item.a }}</p>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { faqList } from "~/data/data";
const activeIndex = ref(null)
function ask(index) {
  if(index === activeIndex.value) {
    activeIndex.value = null
  } else {
    activeIndex.value = index
  }
}
</script>

<style lang="stylus" scoped>
.faq
  min-width 1280px
  max-width 1510px
  margin 0 auto
  padding 0 50px 50px
  box-sizing border-box
  &>h2
    text-align center
    font-size 36px
    font-weight 600
    margin-top 50px
  .faq-list
    background pink
    margin-top 36px
    .faq-item
      background #eee
      line-height 28px
      &:nth-child(odd)
        background #f8f8f8
      .question
        padding 20px 20px
        font-size 18px
        color #333
        font-weight 600
        display flex
        justify-content space-between
        align-items center
        .icon-jia,.icon-jian
          padding 2px 6px
          background #0077aa
          color #FFF
        &:hover
          cursor pointer
      .answer
        padding 10px 20px 30px 2em
        font-size 16px
        color #333
        transition all 1s

</style>
